// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zil98","copyBlock":"styles_copyBlock__1CvA6","promoCode":"styles_promoCode__1D5tI","toast":"styles_toast__qpxWt"};